import { z } from 'zod';
import { optionalUuidString } from '../zod-helpers/index.js';
import { PRODUCT_TREE_CONSTRAINTS } from './constraints.js';
// brandId is intentionally absent -- it's fixed at creation, matching Brand's own
// UpdateBrandInput (companyId isn't updatable either). The only way to move a category to a
// different brand is to deactivate it and create a new one.
export const updateProductTreeInputSchema = z.object({
    // NOT NULL in the DB (VarChar(30)) -- unlike description/parentId, name can't be cleared, so
    // null is rejected here rather than treated as "clear to null" (matches customer/vendor name).
    name: z
        .string()
        .trim()
        .min(1, 'Category name cannot be empty.')
        .max(PRODUCT_TREE_CONSTRAINTS.name.maxLength, `${PRODUCT_TREE_CONSTRAINTS.name.label} must be ${PRODUCT_TREE_CONSTRAINTS.name.maxLength} characters or fewer`)
        .optional(),
    description: z
        .string()
        .trim()
        .max(PRODUCT_TREE_CONSTRAINTS.description.maxLength, `${PRODUCT_TREE_CONSTRAINTS.description.label} must be ${PRODUCT_TREE_CONSTRAINTS.description.maxLength} characters or fewer`)
        .optional()
        .nullable(),
    parentId: optionalUuidString('Invalid parent category selection.').nullish(),
});
//# sourceMappingURL=update-input.js.map